import classNames from 'classnames';

import type { FCC } from '../../../types/common';

import styles from './table_component.module.css';

type Props = {
  className?: string;
  striped?: boolean;
  condensed?: boolean;
};

const TableComponent: FCC<Props> = (props) => (
  <table
    className={classNames(
      props.className,
      styles.root,
      props.striped ? styles.striped : null,
      props.condensed ? styles.condensed : null,
    )}
  >
    {props.children}
  </table>
);

export default TableComponent;
